import { memo } from "react";
import logoImg from "../assets/images/logo.png";
import identityImg from "../assets/images/identity.png";
import moneyIcon from "../assets/images/money-icon.png";
import weightIcon from "../assets/images/weight-icon.png";

interface Props {
  playerName?: string;
  money: number;
  weight: { current: number; max: number };
  onClose: () => void;
  onMyDocuments: () => void;
}

export const Header = memo(function Header({
  playerName = "",
  money,
  weight,
  onClose,
  onMyDocuments,
}: Props) {
  const [firstName, ...rest] = playerName.split(" ");
  const lastName = rest.join(" ");

  return (
    <div className="flex items-center justify-between flex-shrink-0 purista-font text-white">
      {/* Left*/}
      <div className="flex items-center gap-10">
        {/** Branding & Title */}
        <div className="flex items-center gap-6">
          <img src={logoImg} />
          {/** <div className="flex flex-col">
            <span className="text-[20px] font-semibold uppercase leading-[1]">
              Inventory System
            </span>
            <span className="text-[13px] uppercase tracking-wider text-white/50">
              Management of items on same place
            </span>
          </div> */}
        </div>

        {/** pLAYER IDENTITY + ACTIONS */}
        <div className="flex items-center gap-3">
          {/* <img src={identityImg} alt="" /> */}
          {/*      <div className="flex flex-col leading-tight">
            <span className="text-[14px] text-white/50">{firstName}</span>
            <span className="text-[16px] text-white">{lastName}</span>
          </div> */}
          <button
            onClick={onMyDocuments}
            className="px-4 py-1.5 text-[15px] text-[#137FE3] bg-[#137FE3]/25 border border-[#137FE3] rounded-sm transition-colors duration-200 hover:bg-[#137FE3] hover:text-white"
          >
            My Documents
          </button>
        </div>
      </div>

      {/* Right: stats + close */}
      <div className="flex items-center gap-10">
        {/* Money */}
        <div className="flex items-center gap-3">
          <img
            src={moneyIcon}
            alt=""
            className="w-5 h-5 2560px:w-6 2560px:h-6 flex-shrink-0"
            draggable={false}
          />
          <span className="text-white text-[17px] 2560px:text-[19px] purista-font tabular-nums">
            ${" "}
            {money
              .toFixed(2)
              .replace(/\B(?=(\d{3})+(?!\d))/g, " ")
              .replace(".", ".")}
          </span>
        </div>

        {/* Weight */}
        <div className="flex items-center gap-3">
          <img
            src={weightIcon}
            alt=""
            className="w-5 h-5 2560px:w-6 2560px:h-6 flex-shrink-0"
            draggable={false}
          />
          <span className="text-white text-[17px] 2560px:text-[19px] purista-font tabular-nums">
            <span className="text-white">
              {String(weight.current).replace(".", ",")}
            </span>
            <span className="text-white/40  font-normal">
              {" "}
              / {weight.max} kg
            </span>
          </span>
        </div>

        {/* Close */}
        <button
          onClick={onClose}
          className="flex items-center cursor-pointer outline-none rounded-[6px] overflow-hidden py-2 px-3 space-x-3 bg-[#FF1F1F]/5 min-w-[90px]"
          style={{ border: "1px solid #7a1919" }}
        >
          <span className="text-[13px] 2560px:text-[15px] bg-[#FF1F1F]/15 tracking-widest purista-font text-[#FF1F1F] px-[4px] rounded-sm block">
            ESC
          </span>
          <span className="text-white text-[14px] 2560px:text-[16px] uppercase tracking-wider purista-font">
            CLOSE
          </span>
        </button>
      </div>
    </div>
  );
});
